export const STATUS_CONFIG = {
  draft: {
    label: 'Draft',
    color: 'hsl(215, 16%, 50%)',
    bgClass: 'bg-slate-100 text-slate-700 border-slate-200',
    dotClass: 'bg-slate-400',
  },
  script_generating: {
    label: 'Generating script',
    color: 'hsl(38, 78%, 56%)',
    bgClass: 'bg-amber-50 text-amber-800 border-amber-200',
    dotClass: 'bg-amber-500',
  },
  script_ready: {
    label: 'Script ready',
    color: 'hsl(38, 78%, 56%)',
    bgClass: 'bg-amber-50 text-amber-800 border-amber-200',
    dotClass: 'bg-amber-500',
  },
  audio_generating: {
    label: 'Generating audio',
    color: 'hsl(173, 44%, 45%)',
    bgClass: 'bg-teal-50 text-teal-800 border-teal-200',
    dotClass: 'bg-teal-500',
  },
  audio_ready: {
    label: 'Audio ready',
    color: 'hsl(173, 44%, 45%)',
    bgClass: 'bg-teal-50 text-teal-800 border-teal-200',
    dotClass: 'bg-teal-500',
  },
  video_rendering: {
    label: 'Rendering video',
    color: 'hsl(38, 92%, 50%)',
    bgClass: 'bg-amber-50 text-amber-800 border-amber-200',
    dotClass: 'bg-amber-500',
  },
  completed: {
    label: 'Completed',
    color: 'hsl(152, 52%, 38%)',
    bgClass: 'bg-teal-50 text-teal-800 border-teal-200',
    dotClass: 'bg-teal-600',
  },
  failed: {
    label: 'Failed',
    color: 'hsl(0, 72%, 51%)',
    bgClass: 'bg-red-50 text-red-800 border-red-200',
    dotClass: 'bg-red-500',
  },
};

export const PIPELINE_STAGES = [
  'draft',
  'script_generating',
  'script_ready',
  'video_rendering',
  'completed',
];

export const getStatusIndex = (status) => {
  if (status === 'failed') return -1;
  return PIPELINE_STAGES.indexOf(status);
};

export const getStatusConfig = (status) => {
  return STATUS_CONFIG[status] || STATUS_CONFIG.draft;
};
